import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { HeroSection } from './components/HeroSection';
import { IdentificationSection } from './components/IdentificationSection';
import { CodesSection } from './components/CodesSection';
import { QuizSection } from './components/quiz/QuizSection';
import { OfferSection } from './components/OfferSection';
import { StorySection } from './components/StorySection';
import { ForWhomSection } from './components/ForWhomSection';
import { IncludesSection } from './components/IncludesSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { FaqSection } from './components/FaqSection';
import { FinalSection } from './components/FinalSection';
import { Footer } from './components/Footer';
import { WhatsAppFloat } from './components/WhatsAppFloat';
export function App() {
  return <div className="min-h-screen w-full bg-ivory" data-id="element-0" data-mp="23w4e5zrtp20b">
      <MetaPixel data-id="element-1" data-mp="23t8h0dnsuhcx" />
      <HeroSection data-id="element-2" data-mp="3ijxoypkvdyjd" />
      <main data-id="element-3" data-mp="3ikh5q2ysagvt">
        <IdentificationSection data-id="element-4" data-mp="3iiwf2oflbi38" />
        <CodesSection data-id="element-5" data-mp="3ijpet5g4t7bv" />
        <QuizSection data-id="element-6" data-mp="3mljaezbgzl56" />
        <OfferSection data-id="element-7" data-mp="3ml1234bj9ggw" />
        <StorySection data-id="element-8" data-mp="3mk85uxa7a9d0" />
        <ForWhomSection data-id="element-9" data-mp="3mjq45l4rr2xp" />
        <IncludesSection data-id="element-10" data-mp="3rc9d24sih9w6" />
        <BonusSection data-id="element-11" data-mp="3rbzmaezn6ypf" />
        <PricingSection data-id="element-12" data-mp="3rdkgu4lyihna" />
        <FaqSection data-id="element-13" data-mp="3recd7hndojem" />
        <FinalSection data-id="element-14" data-mp="5yhgo69t1c8" />
      </main>
      <Footer data-id="element-15" data-mp="4wxfu7a14id" />
      <WhatsAppFloat data-id="element-16" data-mp="5gel8p3rovc" />
    </div>;
}